export default function () {
    const galleryId = "uploadPreview";
    const gallery = document.getElementById(galleryId);

    function previewImage(file) {
        const imageType = /image.*/;

        if (!file.type.match(imageType)) {
            throw "File Type must be an image";
        }

        const thumb = document.createElement("div");
        thumb.classList.add('thumbnail');

        const img = document.createElement("img");
        img.file = file;
        thumb.appendChild(img);
        gallery.appendChild(thumb);

        const reader = new FileReader();
        reader.onload = (function (aImg) { return function (e) { aImg.src = e.target.result; }; })(img);
        reader.readAsDataURL(file);
    }

    const productImageUpload = document.getElementById('ProductImageUpload');

    if (!productImageUpload) return;

    productImageUpload.addEventListener('change', function () {
        while (gallery.firstChild) {
            gallery.removeChild(gallery.firstChild);
        }

        for (let i = 0; i < this.files.length; i++) {
            const file = this.files[i];

            console.group("File " + i);

            console.log("name : " + file.name);
            console.log("size : " + file.size);

            console.log("type : " + file.type);
            console.log("date : " + file.lastModified);

            console.groupEnd();
            previewImage(file);
        }

    }, false);
}